import { createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2c7e1dd8")

_pushScopeId("data-v-2c7e1dd8")
const _hoisted_1 = { class: "controller-component flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "sector" }, null, -1)
const _hoisted_3 = { class: "controllers flex justify-around" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "icon" }
const _hoisted_6 = { class: "icon" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "logout-text align-center" }, "是否退出当前账号?", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SvgIcon = _resolveComponent("SvgIcon")
  const _component_person_center = _resolveComponent("person-center")
  const _component_my_modal = _resolveComponent("my-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_SvgIcon, {
          class: "pointer my-icon",
          icon: "user",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleShowModalClick('personCenter')))
        })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_SvgIcon, {
          class: "pointer my-icon",
          icon: "bell"
        })
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_SvgIcon, {
          class: "pointer my-icon",
          icon: "help",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleShowModalClick('tips')))
        })
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_SvgIcon, {
          class: "pointer my-icon",
          icon: "exit",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleShowModalClick('logout')))
        })
      ])
    ]),
    (_ctx.modalValide.personCenter)
      ? (_openBlock(), _createBlock(_component_person_center, {
          key: 0,
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleBackClick('personCenter')))
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_my_modal, {
      onOnOk: _ctx.handleLogoutOk,
      onOnCancel: _ctx.handleLogoutCancel,
      visible: _ctx.modalValide.logout,
      okText: "是",
      cancelText: "否"
    }, {
      content: _withId(() => [
        _hoisted_8
      ]),
      _: 1
    }, 8, ["onOnOk", "onOnCancel", "visible"])
  ]))
})